module.exports = __webpack_public_path__ + "img/108.8.674e5e6a.png";